exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".theme{display:flex;flex-direction:column;justify-content:space-between}.theme__height-max{height:100%;min-height:500px}.theme__collage{flex-direction:initial;justify-content:initial}.theme--new_slider,.theme--video_slider{height:inherit}", ""]);

